import { useCallback, useEffect, useState } from 'react';
import { initialStepValues, recipeStepsFullPath, validationStepSchema } from '../../constants';
import { IRecipeStepEditable } from '../../../../types/recipes-types';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { Dispatch, RootState } from '../../../../store/store';
import { connect } from 'react-redux';
import { RecipeStepFormCard } from '../../Components/RecipeStepFormCard';
import CycleMeasurement from '../../../../enums/cycle-measurement';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';

type ComponentProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const RecipeStepCreate = ({ createStep, steps, getUnits }: ComponentProps) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [prefferedUnits, setPrefferedUnits] = useState<CycleMeasurement | null>(null);

  const onSubmitHandler = useCallback(
    async (values: IRecipeStepEditable) => {
      await createStep({ id, data: { ...values, order: steps.length + 1 } });
      navigate(generatePath(recipeStepsFullPath, { id }));
    },
    [createStep, steps, id, navigate],
  );

  const fetchDataHandler = async () => {
    const units = await getUnits();
    setPrefferedUnits(units);
  };

  useEffect(() => {
    fetchDataHandler();
  }, []);

  if (!prefferedUnits) {
    return (
      <div className="c-recipe-step-create flex justify-center items-center p-4">
        <SpinnerLoader />
      </div>
    );
  }

  return (
    <RecipeStepFormCard
      initialValues={initialStepValues}
      validationSchema={validationStepSchema}
      submitButtonName="Create"
      formName="Create Recipe Step"
      onSubmit={onSubmitHandler}
      prefferedUnits={prefferedUnits}
    />
  );
};

const mapState = (state: RootState) => ({
  step: state.recipes.step,
  steps: state.recipes.steps,
});

const mapDispatch = (dispatch: Dispatch) => ({
  createStep: dispatch.recipes.createStep,
  getUnits: dispatch.organizations.getOrganizationUnits,
});

export default connect(mapState, mapDispatch)(RecipeStepCreate);
